<app-spinner-overlay></app-spinner-overlay>
<app-compila-sintesi-sostenibilita
  [isPermessoSoloRead]="data.isPermessoSoloRead"
  [titolo]="titolo"
  [valueToggleAnni]="data.valueToggleAnni"
  [idSintesiSostenibilita]="idContesto"
  [esercizio]="esercizio"
  [compilazione]="compilazione"
  [salvaCompilazione]="finitaCompilazione"
  (loading)="loading($event)"
  (chiudoCompilazione)="chiudi()"
  *ngIf="compilazione"
  [tipo]="data.tipo"
></app-compila-sintesi-sostenibilita>
